import type { PatientDetailsCardProps } from './types/patientDetailsCard.types';
import { usePatientForm } from '../../hooks/usePatientForm';
import { PatientDetailsView } from './PatientDetailsView';
import { PatientDetailsForm } from './PatientDetailsForm';
import styles from './PatientDetailsCard.module.css';

export type { PatientDetailsCardProps };

// TODO: replace custom elements with components from qampo-ui-library
export const PatientDetailsCard = ({
  patient,
  locationId,
  mode,
  createPrefill,
  onEditStart,
  onEditEnd,
  onPatientUpdated,
  onPatientCreated
}: PatientDetailsCardProps) => {
  const {
    form,
    setForm,
    fieldErrors,
    patientRoomNeeds,
    allRoomProperties,
    handleEditClick,
    handleCreatePatient,
    handleUpdatePatient
  } = usePatientForm({
    patient,
    locationId,
    mode,
    createPrefill,
    onEditStart,
    onEditEnd,
    onPatientUpdated,
    onPatientCreated
  });

  const isEditing = mode === 'edit' || mode === 'create';

  return (
    <div className={styles.card}>
      {!isEditing && patient ? (
        <PatientDetailsView
          patient={patient}
          patientRoomNeeds={patientRoomNeeds}
          onEditClick={handleEditClick}
        />
      ) : (
        <PatientDetailsForm
          form={form}
          setForm={setForm}
          fieldErrors={fieldErrors}
          mode={mode === 'create' ? 'create' : 'edit'}
          allRoomProperties={allRoomProperties}
          onSave={mode === 'create' ? handleCreatePatient : handleUpdatePatient}
        />
      )}
    </div>
  );
};
